import React from 'react';
import { styled } from '@mui/material';

import {
    ActivityList,
    Analytics,
    TaskList,
    GroupProgressInformation,
    TeamInformation,
} from 'components/organisms/Dashboard';
import { Container, Stack } from 'shell/components';

const Tablet = ({
    course,
    group = {},
    groupMembers = [],
    instructorMembers = [],
    status,
    myTasks = [],
    mySubtasks = [],
    currentAccountId,
    activityList,
    setActivitySettings,
}) => {
    return (
        <Container device={'tablet'}>
            <CustomTopStack className={'dashboard-1'} spacing={5}>
                <TeamInformation
                    groupName={group?.name}
                    courseName={course?.name}
                    members={groupMembers}
                    instructors={instructorMembers}
                    status={status}
                />
                <CustomGroupProgressInformation />
            </CustomTopStack>
            <CustomBottomStack className={'dashboard-2'} direction={'row'}>
                <Analytics students={groupMembers} />
                <TaskList taskList={myTasks} subtaskList={mySubtasks} />
                <ActivityList
                    currentAccountId={currentAccountId}
                    activityList={activityList}
                    groupMembers={groupMembers}
                    instructorMembers={instructorMembers}
                    setActivitySettings={setActivitySettings}
                />
            </CustomBottomStack>
        </Container>
    );
};

const CustomTopStack = styled(Stack)(() => {
    return {
        width: '100%',
        '& > div': {
            borderRadius: '12px',
        },
        '& > div:nth-child(3), & > div:nth-child(4), & > div:nth-child(5)': {
            borderRadius: '12px 12px 0 0',
        },
    };
});

const CustomBottomStack = styled(Stack)(({ theme }) => {
    return {
        marginTop: theme.spacing(5),
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridTemplateRows: '1fr',
        gridGap: theme.spacing(3),
        width: '100%',
        height: 'calc(100vh - 64px - 20px - 353px - 12px)',
        minHeight: '100%',
        '& > div': {
            height: '100%',
        },
        '& > div:nth-child(3), & > div:nth-child(4), & > div:nth-child(5)': {
            borderRadius: '12px 12px 0 0',
        },
    };
});

const CustomGroupProgressInformation = styled(GroupProgressInformation)(() => {
    return {
        gridColumn: '2 / 4',
    };
});

export default Tablet;
